import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NiveauQualification } from 'src/app/shared/models/niveauQualification';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NiveauQualificationModalAjoutComponent } from '../modal/niveauQualification-modal-ajout/niveauQualification-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { NiveauQualificationModalDetailComponent } from '../modal/niveauQualification-modal-detail/niveauQualification-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-niveauQualification',
	templateUrl: './list-niveauQualification.component.html',
	styleUrls: ['./list-niveauQualification.component.scss']
})
export class ListNiveauQualificationComponent implements OnInit {
	niveauQualification: NiveauQualification[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	niveauQualificationCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editNiveauQualificationModalRef: BsModalRef;
	addNiveauQualificationModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getNiveauQualification();
		this.isAddable = true;
	}

	getNiveauQualification(): void {
		this.isListingLoading = true;
		this.facade.niveauQualificationService.getAllNiveauQualification().subscribe({
			next: (val) => {
				this.niveauQualification = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.niveauQualification.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.niveauQualification = [];
			}
		});
	}

	selectNiveauQualification(niveauQualification: NiveauQualification): void {
		const link = ['/niveauQualification', niveauQualification.id];
		this.router.navigate(link);
	}

	importNiveauQualification(event: any): void {
		this.niveauQualificationCsvFile = event.target.files[0];

		this.facade.niveauQualificationService
			.importNiveauQualification(this.niveauQualificationCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} niveauQualification ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getNiveauQualification();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addNiveauQualificationModalRef = this.modalService.show(
			NiveauQualificationModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addNiveauQualificationModalRef.onHide.subscribe((reason: string | any) => {
			this.getNiveauQualification();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(niveauQualification: NiveauQualification) {
		const initialState = {
			niveauQualification: niveauQualification
		};
		this.editNiveauQualificationModalRef = this.modalService.show(
			NiveauQualificationModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editNiveauQualificationModalRef.onHide.subscribe((reason: string | any) => {
			this.getNiveauQualification();
		});
	}
}
